import { render, staticRenderFns } from "./SecondExtraInfoDetails.component.vue?vue&type=template&id=0277a743&"
import script from "./SecondExtraInfoDetails.component.vue?vue&type=script&lang=ts&"
export * from "./SecondExtraInfoDetails.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports